import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import DefaultLayout from '../components/DefaultLayout';
import { useDispatch, useSelector } from 'react-redux';
import { getAllBookings } from '../redux/actions/bookingActions';
import { Col, Row } from 'antd';
import Spinner from '../components/Spinner';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';


function UserBookings() {
    const dispatch = useDispatch();
    const { bookings } = useSelector((state) => state.bookings);
    const { loading } = useSelector((state) => state.alerts);

    const user = JSON.parse(localStorage.getItem('user'));

    useEffect(() => {
        try {
            dispatch(getAllBookings());  
        } catch (error) {
            console.log(error);
        }
        
    }, []);

    return (
        <DefaultLayout>
            {loading && (<Spinner />)}

            <h3 style={{color: 'black'}} className="text-center mt-4"><span><strong>My Bookings</strong></span></h3>
    
            <Row justify="center" gutter={24}>
                <Col lg={20} sm={24}>

                    {bookings.filter( o => o.user == user._id ).map((booking) => {
                        console.log('booking =>',booking);
                        return <Row key={booking._id} className="bs1 mt-3 text-left">
                            <Col lg={8} sm={24}>
                                <p>BookingId  :  <b>{booking._id}</b></p>
                                <p>Car Name  :  <b>{booking.car?.name}</b></p>
                                <p>Total hours : <b>{booking.totalHours}</b></p>
                                <p>Rent per hour : <b>{booking.car?.rentPerHour}</b></p>
                                <p>Total amount : <b>{booking.totalAmount}</b> USD/-</p>
                            </Col>

                            <Col lg={10} sm={24}>
                                <p>Transaction Id : <b>{booking.transactionId}</b></p>
                                <p>From: <b>{booking.bookedTimeSlots.from}</b></p>
                                <p>To: <b>{booking.bookedTimeSlots.to}</b></p>
                                <p>Date of booking: <b>{moment(booking.createdAt).format('MMM DD yyyy HH:MM')}</b></p>
                            </Col>

                            <Col lg={6} sm={24} className='text-right'>
                                <img style={{borderRadius:5}} src={booking.car?.image?.url[0]}  height="140" className="p-2"/>
                            </Col>
                        </Row>;
                        
                    })}
          
                </Col>

                <Col lg={10} sm={24} xs={24} className="text-right p-3 mt-5">
                    <div>
                        <button className="btn1" style={{backgroundColor: 'orangered', color: 'white'}}>
                            <Link className='book' to='/home'>
                                <FontAwesomeIcon icon={faAngleLeft} size="3x" className='m-0' style={{color: 'orangered'}}/>Back
                            </Link>
                        </button>
                    </div>
                </Col> 
            </Row>
        </DefaultLayout>
    );
}

export default UserBookings;
